import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default class MagneticButton {
	constructor(container, options) {
		const _options = {
			inner_wrap: '.inner-wrap',
			inner_anim: '.inner-anim',
			movement: .5,
			isPill: false,
		};
		this.options = { ..._options, ...options };

		this.container = container;
		this.inner_wrap = this.container.querySelector(this.options.inner_wrap);
		this.inner_anim = this.container.querySelectorAll(this.options.inner_anim);

		this.isPill = this.options.isPill || this.container.classList.contains('__pill');
		/* 		this.width = window.innerWidth;
				this.height = window.innerHeight; */
		this.movement = this.options.movement;
		this.init();
		this.events();
	}

	init = () => { }

	events = () => {
		this.container.addEventListener('mouseenter', this.onMouseEnter);
		this.container.addEventListener('mouseleave', this.onMouseLeave);
		this.container.addEventListener('mousemove', this.onMouseMove);
	}

	onMouseEnter = (e) => {
		gsap.killTweensOf(this.container)
		//gsap.to(this.inner_wrap, { scale: 1.2, autoAlpha: 1, duration: 0.2, ease: 'power.out' })
	}
	onMouseLeave = (e) => {
		gsap.to(this.inner_wrap, { x: 0, y: 0, duration: 0.6, ease: 'power.out', });
		gsap.to(this.inner_anim, { x: 0, y: 0, duration: 0.8, ease: 'power.out' });
	}

	onMouseMove = (e) => {
		//var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		var boundingRect = this.inner_wrap.getBoundingClientRect();
		var relX = e.pageX - boundingRect.left;
		var relY = e.pageY - boundingRect.top;
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;


		gsap.to(this.inner_wrap, {
			x: (i) => {
				return (relX - boundingRect.width / 2) * (this.movement - (i + 1) * this.movement / 2)
			},
			y: (i) => {
				return (relY - boundingRect.height / 2 - scrollTop) * (this.movement - (i + 1) * this.movement / 2)
			},
			duration: 0.6,
			ease: 'power.out'
		});
		gsap.to(this.inner_anim, {
			x: (i) => {
				i = i == 1 ? 0.5 : i;
				return -(relX - boundingRect.width / 2) * (this.movement - (i + 1) * this.movement / 2)
			},
			y: (i) => {
				i = i == 1 ? 0.5 : i;

				return -(relY - boundingRect.height / 2 - scrollTop) * (this.movement - (i + 1) * this.movement / 2)
			},
			duration: 0.8,
			ease: 'power.inOut',
		});

	}

	destroy = () => {
		console.log('destroy magnetic button');

		this.inner_wrap.removeEventListener('mouseenter', this.onMouseEnter);
		this.inner_wrap.removeEventListener('mouseleave', this.onMouseLeave);
		this.inner_wrap.removeEventListener('mousemove', this.onMouseMove);
	}
}